import React, { useState } from 'react';
import Dialog from '../../../../Components/Dialog';
import CampaignRoundedIcon from '@mui/icons-material/CampaignRounded';
import CampaignDialogContent from './Content';

const NewCampaignDialog = function NewCampaignDialog({
  open,
  onClose,
  onSubmit,
  defaultData = null,
  edit = false,
}) {
  const [disableSubmit, setDisableSubmit] = useState(true);

  const handleChange = (value) => {
    setDisableSubmit(value);
  };

  return (
    <Dialog
      id="new-campaign-dialog"
      title={edit ? 'EDIT_CAMPAIGN' : 'NEW_CAMPAIGN'}
      icon={<CampaignRoundedIcon />}
      open={open}
      onClose={onClose}
      onCancel={onClose}
      onSubmit={onSubmit}
      disableSubmit={disableSubmit}
      width="sm"
      fullWidth
      disableScroll
      disableBackdropClick
      disableEscapeKeyDown
      form
      dividers
    >
      <CampaignDialogContent
        handleChangeDisableSubmit={handleChange}
        defaultData={defaultData}
      />
    </Dialog>
  );
};

export default NewCampaignDialog;
